"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var react_media_1 = __importDefault(require("react-media"));
var button_1 = require("@kaizen/button");
var component_library_1 = require("@kaizen/component-library");
var arrow_forward_icon_svg_1 = __importDefault(require("@kaizen/component-library/icons/arrow-forward.icon.svg"));
var close_icon_svg_1 = __importDefault(require("@kaizen/component-library/icons/close.icon.svg"));
var draft_tooltip_1 = require("@kaizen/draft-tooltip");
var typography_1 = require("@kaizen/typography");
var GuidanceBlock_module_scss_1 = __importDefault(require("./GuidanceBlock.module.scss"));
var CancelButton = function (_a) {
    var onClick = _a.onClick;
    return (react_1["default"].createElement("button", { className: GuidanceBlock_module_scss_1["default"].cancel, type: "button", onClick: onClick },
        react_1["default"].createElement("span", null,
            react_1["default"].createElement(component_library_1.Icon, { icon: close_icon_svg_1["default"], role: "img", title: "close notification" }))));
};
var WithTooltip = function (_a) {
    var tooltipProps = _a.tooltipProps, children = _a.children;
    return !!tooltipProps ? (react_1["default"].createElement(draft_tooltip_1.Tooltip, __assign({}, tooltipProps), children)) : (react_1["default"].createElement(react_1["default"].Fragment, null, children));
};
/**
 * {@link https://cultureamp.design/components/guidance-block/ Guidance} |
 * {@link https://cultureamp.design/storybook/?path=/docs/components-guidance-block--default-story Storybook}
 */
var GuidanceBlock = /** @class */ (function (_super) {
    __extends(GuidanceBlock, _super);
    function GuidanceBlock(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            hidden: false,
            removed: false,
            mediaQueryLayout: ""
        };
        _this.containerRef = react_1["default"].createRef();
        _this.renderActions = function (actions, withActionButtonArrow) {
            // Checks if container query is mobile configuration
            var componentIsMobile = _this.state.mediaQueryLayout.includes("centerContent");
            return (react_1["default"].createElement(react_media_1["default"], { query: "(max-width: 767px)" }, function (isMobile) {
                var _a, _b, _c;
                return (react_1["default"].createElement(component_library_1.Box, { mr: isMobile || componentIsMobile
                        ? 0
                        : _this.props.layout === "default"
                            ? 0.5
                            : 0 },
                    react_1["default"].createElement("div", { className: (0, classnames_1["default"])(GuidanceBlock_module_scss_1["default"].buttonContainer, (actions === null || actions === void 0 ? void 0 : actions.secondary) && GuidanceBlock_module_scss_1["default"].secondaryAction) },
                        react_1["default"].createElement(WithTooltip, { tooltipProps: actions.primary.tooltip },
                            react_1["default"].createElement(button_1.Button, __assign({ icon: withActionButtonArrow ? arrow_forward_icon_svg_1["default"] : undefined, iconPosition: "end" }, actions.primary, { fullWidth: isMobile || componentIsMobile }))),
                        (actions === null || actions === void 0 ? void 0 : actions.secondary) && (react_1["default"].createElement(WithTooltip, { tooltipProps: actions.secondary.tooltip },
                            react_1["default"].createElement("div", { className: GuidanceBlock_module_scss_1["default"].secondaryAction },
                                react_1["default"].createElement(button_1.Button, __assign({ secondary: true }, actions.secondary, { onClick: ((_a = _this.props) === null || _a === void 0 ? void 0 : _a.secondaryDismiss)
                                        ? function () { return _this.dismissBanner(); }
                                        : (_c = (_b = _this.props.actions) === null || _b === void 0 ? void 0 : _b.secondary) === null || _c === void 0 ? void 0 : _c.onClick, fullWidth: isMobile || componentIsMobile }))))))));
            }));
        };
        _this.renderIllustrationType = function (illustration, illustrationType) {
            return illustrationType === "scene"
                ? react_1["default"].cloneElement(illustration, { enableAspectRatio: true })
                : illustration;
        };
        _this.dismissBanner = _this.dismissBanner.bind(_this);
        _this.onTransitionEnd = _this.onTransitionEnd.bind(_this);
        return _this;
    }
    GuidanceBlock.prototype.componentDidMount = function () {
        if (this.props.layout === "inline" || this.props.layout === "stacked") {
            this.containerQuery();
        }
    };
    GuidanceBlock.prototype.dismissBanner = function () {
        var _a, _b;
        this.setState({ hidden: true });
        (_b = (_a = this.props.actions) === null || _a === void 0 ? void 0 : _a.dismiss) === null || _b === void 0 ? void 0 : _b.onClick();
    };
    GuidanceBlock.prototype.onTransitionEnd = function (e) {
        // Be careful: this assumes the final CSS property to be animated is "margin-top".
        if (this.state.hidden && e.propertyName === "margin-top") {
            this.setState({ removed: true });
        }
    };
    GuidanceBlock.prototype.containerQuery = function () {
        var _this = this;
        var resizeObserver = new ResizeObserver(function (entries) {
            if (entries.length === 1) {
                _this.setMediaQueryLayout(entries[0].contentRect.width);
            }
        });
        resizeObserver.observe(this.containerRef.current);
    };
    GuidanceBlock.prototype.setMediaQueryLayout = function (width) {
        if (width <= 320) {
            this.setState({
                mediaQueryLayout: "centerContent"
            });
        }
        else {
            this.setState({ mediaQueryLayout: "" });
        }
    };
    GuidanceBlock.prototype.bannerClassName = function (props) {
        return (0, classnames_1["default"])(GuidanceBlock_module_scss_1["default"].banner, props.variant && GuidanceBlock_module_scss_1["default"][props.variant], props.layout && GuidanceBlock_module_scss_1["default"][props.layout], this.state.hidden && GuidanceBlock_module_scss_1["default"].hidden, this.state.mediaQueryLayout === "centerContent" && GuidanceBlock_module_scss_1["default"].centerContent, props.noMaxWidth && GuidanceBlock_module_scss_1["default"].noMaxWidth, props.illustrationType === "scene" && GuidanceBlock_module_scss_1["default"].hasSceneIllustration, props.smallScreenTextAlignment === "left" &&
            GuidanceBlock_module_scss_1["default"].smallScreenTextAlignment);
    };
    GuidanceBlock.prototype.marginTop = function () {
        if (this.state.hidden && this.containerRef.current) {
            return -this.containerRef.current.clientHeight + "px";
        }
        return "0";
    };
    GuidanceBlock.prototype.render = function () {
        var _a;
        if (this.state.removed) {
            return null;
        }
        var _b = this.props, actions = _b.actions, illustration = _b.illustration, persistent = _b.persistent, withActionButtonArrow = _b.withActionButtonArrow, illustrationType = _b.illustrationType;
        return (react_1["default"].createElement("div", { className: this.bannerClassName(this.props), style: {
                marginTop: this.marginTop()
            }, ref: this.containerRef, onTransitionEnd: this.onTransitionEnd },
            react_1["default"].createElement("div", { className: GuidanceBlock_module_scss_1["default"].illustrationWrapper },
                react_1["default"].createElement("div", { className: GuidanceBlock_module_scss_1["default"].illustration }, this.renderIllustrationType(illustration, illustrationType))),
            react_1["default"].createElement("div", { className: GuidanceBlock_module_scss_1["default"].descriptionAndActions },
                react_1["default"].createElement("div", { className: GuidanceBlock_module_scss_1["default"].descriptionContainer },
                    "content" in this.props && this.props.content,
                    "text" in this.props && (react_1["default"].createElement(react_1["default"].Fragment, null,
                        react_1["default"].createElement("div", { className: GuidanceBlock_module_scss_1["default"].headingWrapper },
                            react_1["default"].createElement(typography_1.Heading, { tag: (_a = this.props.text.titleTag) !== null && _a !== void 0 ? _a : "h3", variant: "heading-3" }, this.props.text.title)),
                        react_1["default"].createElement(typography_1.Paragraph, { tag: "p", variant: "body" }, this.props.text.description)))),
                (actions === null || actions === void 0 ? void 0 : actions.primary) &&
                    this.renderActions(actions, withActionButtonArrow)),
            !persistent && react_1["default"].createElement(CancelButton, { onClick: this.dismissBanner })));
    };
    GuidanceBlock.defaultProps = {
        layout: "default",
        variant: "default",
        withActionButtonArrow: true,
        noMaxWidth: false,
        illustrationType: "spot",
        smallScreenTextAlignment: "center"
    };
    return GuidanceBlock;
}(react_1["default"].Component));
exports["default"] = GuidanceBlock;
//# sourceMappingURL=GuidanceBlock.js.map